import { Axios } from "../lib/axios";
export const QuantdataServices = {
  getQuantdata,
};

function getQuantdata(companyId, segmentId) {
  return Axios.get(`company/${companyId}/segment/${segmentId}/quantData`);
}
